import { get } from '@Green-Dot-Corporation/eureka-lib-fetch-utils';

class Backend {
    static type = 'backend';

    init(services, backendOptions, i18nextOptions) {
        this.services = services;
        this.backendOptions = backendOptions ?? {};
        this.i18nextOptions = i18nextOptions;
    }

    read(language, namespace, callback) {
        const {
            defaultTranslations,
            shouldLoadStrings,
            localizationPath,
            loadURL,
        } = this.backendOptions;

        const promise =
            defaultTranslations?.[language]?.() || Promise.resolve();

        if (shouldLoadStrings) {
            let i18nURL = loadURL;

            if (!i18nURL) {
                i18nURL = `${localizationPath}/{{locale}}.json`;
            }
            const replacedLoadURL = i18nURL.replace('{{locale}}', language);

            promise
                .then((translations) => {
                    get(replacedLoadURL, { credentials: 'same-origin' })
                        .then((response) => {
                            const defaultLang = translations ?? {};

                            const overrideLang = response ?? {};

                            const merged = { ...defaultLang, ...overrideLang };

                            callback(undefined, merged);
                        })
                        .catch(() => {
                            callback(undefined, translations);
                        });
                })
                .catch(() => {
                    callback(false);
                });
        } else {
            promise.then((translations) => {
                callback(undefined, translations);
            });
        }
    }
}

export default Backend;
